import React, { useState, useRef, useEffect, useContext } from 'react'
import styled from 'styled-components'
import WalletConnectionModal from './WalletConnectionModal'
import { useOnClickOutside } from '../hooks/rendering'
import { Web3Context } from '../hooks/web3'
import {
  manipulateModal,
  manipulateWhenNoWallet,
} from './connection/wallet-connect'
import { DisconnectPopup } from './connection/DisconnectPopup'
import { accountShortcut } from '../utils/account'
import { useTransactions } from './transactions/TransactionContext'
import { SwaapLoader } from './catalog/SwaapLoader'
import { lastClickOnWallet } from '../utils/document-visibility'
import { now } from '../utils/dates'
import { createWalletEvent } from 'user-events-segment'
import {
  getAvailableProviderList,
  getProviderType,
} from './connection/provider'

const _Wallet = styled.button<{ hasPendingTx: boolean }>`
  font-family: Montserrat-Medium;
  color: ${({ theme, hasPendingTx }) =>
    hasPendingTx ? theme.walletTextColorPending : theme.walletTextColor};
  background-color: ${({ theme, hasPendingTx }) =>
    hasPendingTx
      ? theme.walletBackgroundColorPending
      : theme.walletBackgroundColor};
  box-shadow: ${({ theme, hasPendingTx }) =>
    hasPendingTx ? theme.walletShadow : 'none'};

  border-radius: 2.4rem;
  padding: 0.7rem 1.4rem;
  font-size: 2rem;
  text-align: center;
  align-self: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.walletBorderColor};

  :hover {
    border: 1px solid ${({ theme }) => theme.walletBorderColorHover};
  }

  /* Mobiles */
  @media (max-width: 640px) {
    font-size: 1.7rem;
  }
`
const Span = styled.span`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
`
// TODO: useMemo somewhere, too much rerender
function Wallet() {
  const ref = useRef()
  // State for our modal
  const [maybeShowWalletConnectionModal, setMaybeShowWalletConnectionModal] =
    useState(false)
  const [showWalletConnectionModal, setShowWalletConnectionModal] =
    useState(false)
  // Call hook passing in the ref and a function to call on outside click
  useOnClickOutside(ref, () => {
    setMaybeShowWalletConnectionModal(false)
    setShowWalletConnectionModal(false)
  })

  const web3Context = useContext(Web3Context)
  const { transactions, dispatcher } = useTransactions()
  const pendingTransactionsCount = transactions.pending.length
  const hasPendingTx = pendingTransactionsCount > 0

  const { account, disconnect } = web3Context

  const [showDisconnectPopup, setShowDisconnectPopup] = useState(false)

  useEffect(() => {
    if (web3Context['isConnectedToWeb3']) {
      setMaybeShowWalletConnectionModal(false)
      setShowWalletConnectionModal(false)
    } else {
      if (maybeShowWalletConnectionModal) {
        setShowWalletConnectionModal(true)
      }
    }
  }, [web3Context['isConnectedToWeb3'], maybeShowWalletConnectionModal])

  function handleWalletClick() {
    handleAllowWeb3()

    createWalletEvent().clicked_connect_wallet(getAvailableProviderList())
    setTimeout(() => {
      manipulateModal()
      manipulateWhenNoWallet()
    }, 75)
  }

  function handleAllowWeb3() {
    // TODO: this is probably not needed anymore
    lastClickOnWallet.time = now()
    if (!web3Context['allowWeb3']) {
      // we want to connect
      web3Context['setAllowWeb3'](true)
    } else {
      setShowDisconnectPopup(true)
      createWalletEvent().opened_account_information()
    }
  }

  return (
    <>
      <_Wallet onClick={() => handleWalletClick()} hasPendingTx={hasPendingTx}>
        <Span>
          {account ? (
            <>
              {hasPendingTx ? (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <span className="numeric">{pendingTransactionsCount}</span>
                  <span className="ml5 mr5 light fs18">pending</span>
                  <SwaapLoader color={'white'} />
                </div>
              ) : (
                accountShortcut(account)
              )}
            </>
          ) : (
            <>{account ? 'Connect to a wallet' : 'Connect Wallet'}</>
          )}
        </Span>
      </_Wallet>
      <>
        {showWalletConnectionModal ? (
          <WalletConnectionModal
            handleRef={ref}
            handleAllowWeb3={handleAllowWeb3}
          />
        ) : (
          <div></div>
        )}
      </>
      {showDisconnectPopup && (
        <DisconnectPopup
          onExit={() => {
            setShowDisconnectPopup(false)
          }}
          onDisconnect={() => {
            disconnect()
            setShowDisconnectPopup(false)
          }}
        />
      )}
    </>
  )
}

export default Wallet
